/** Server-calculated native coupon prices follow the selected WooCommerce variation. */
export const initializeProductCoupon = (page) => {
    const root = page.querySelector('[data-product-coupon]');
    if (!root) return () => {};
    const offers = JSON.parse(root.dataset.couponOffers);
    const sync = (variation = null) => {
        const offer = variation ? offers.variants[variation.variation_id] : offers.initial;
        root.hidden = !offer || variation?.is_in_stock === false || variation?.is_purchasable === false;
        if (root.hidden) return;
        root.querySelector('[data-coupon-price]').innerHTML = offer.price_html;
        root.querySelector('[data-coupon-code]').textContent = offer.code;
        root.querySelector('[data-coupon-from]').hidden = !offer.from;
        root.querySelector('[data-coupon-selected]').hidden = !offer.selected_variants;
        const conditions = root.querySelector('[data-coupon-conditions]');
        conditions.textContent = offer.conditions;
        conditions.hidden = !offer.conditions;
        root.dataset.expires = offer.ends;
        root.dataset.serverNow = offer.now;
        const time = root.querySelector('[data-coupon-countdown]');
        time.dateTime = offer.datetime;
        time.setAttribute('aria-label', `${root.dataset.couponDeadlineLabel} ${offer.date}`);
        time.textContent = offer.date;
        root.ownerDocument.dispatchEvent(new Event('ovalia:coupon-changed'));
    };
    return sync;
};
